import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=3d9d5ba3"
import script from "./Pay.vue?vue&type=script&lang=js"
export * from "./Pay.vue?vue&type=script&lang=js"
import style0 from "./Pay.vue?vue&type=style&index=0&id=3d9d5ba3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports